/**
 * Node Modules
 */
import React, { useState } from 'react'
import { Link } from 'gatsby'
import Zendesk, {ZendeskAPI} from "react-zendesk";
import Cookies from "js-cookie"


/**
 * Application Modules
 */
import './style.css'
import Spacer from '../components/spacer'

const COOKIE_GATSBY_PLUGIN_GOOGLE_ANALYTICS_GDPR_COOKIES_ENABLED = "gatsby-plugin-google-analytics-gdpr_cookies-enabled"
const ZENDESK_KEY = "11430b22-22ac-4c72-9363-f1754f1ce3c5";

if (typeof window !== 'undefined') {
  ZendeskAPI("webWidget", "setLocale", "en-US");
}

let initialState = true
if (typeof window !== 'undefined') {
  if (Cookies.get(COOKIE_GATSBY_PLUGIN_GOOGLE_ANALYTICS_GDPR_COOKIES_ENABLED) === "true") {
    initialState = false
  }
}

const setting = {
  launcher: {
    chatLabel: {
      "en-US": "Support",
    }
  }
};

/**
 * Component
 */
export default function GDPRBanner() {
  const [visible, setVisible] = useState(initialState)

  const handleCookiesAccept = () => {
    if (typeof window !== 'undefined') {
      Cookies.set('gatsby-gdpr-facebook-pixel', true)
      Cookies.set(COOKIE_GATSBY_PLUGIN_GOOGLE_ANALYTICS_GDPR_COOKIES_ENABLED, true)
    }

    setVisible(false)
    initialState = false

    // if (typeof window !== 'undefined') location.reload()
  }

  if (!visible) {
    return (
      <Zendesk zendeskKey={ZENDESK_KEY} {...setting} />
    )
  } else return (
    <div className="gdpr-banner">
      <div className="gdpr-banner__content">
        <Spacer size={[10, 55]} />
        <h2 className="gdpr-banner__hed">Cookies</h2>
        <Spacer size={[10, 20]} />
        <p className="gdpr-banner__dek">
          We use cookies on our Website to improve your browsing experience, to improve the
          performance and to gather statistics. If you wish to know more about cookies, how to prevent
          the installation of these cookies and change the settings of your browser, <Link to="/cookies-policy">click here</Link>. 
        </p>
        <Spacer size={[30, 40]} />
        <div className="flex">
          <button className="button button--f2 button--yellow reset" onClick={handleCookiesAccept}>Accept all cookies</button>
        </div>
        <Spacer size={[0, 55]} />
      </div>
    </div>
  )
}
